import React from 'react';
import { useTranslation } from 'react-i18next';
import { CandidateDetail } from '../../../../models/candidate-detail.model';
import { Item, Linked, LinkExt, List, SectionBlock } from '../../talent.styled';
import { BulletTitle, TitleAbout } from '../about/about.styled';
import { Skill, SkillsList } from '../candidate-skills/candidate-skills.styled';

interface ArticlesProps {
    candidate: CandidateDetail;
    isLocked?: boolean | true;
}

const Articles: React.FC<ArticlesProps> = ({ candidate, isLocked }) => {
    const { t } = useTranslation('private-home-page');

    return (
        <SectionBlock>
            <TitleAbout>{t('talent.dioArticles')}</TitleAbout>
            <List>
                {candidate.articles.map((article, index) => (
                    <Item key={`achievement-${index}`}>
                        <BulletTitle>
                            <Linked target="_blank" href={article.public_url} disabled={isLocked} >
                                {article.name} <LinkExt src={isLocked ? "/assets/img/borderless-lock-icon.svg" : "/assets/img/link-ext.svg"} />
                            </Linked>
                        </BulletTitle>
                        <SkillsList>
                            {article?.skills?.map(skill =>
                                <Skill key={skill.id} >{skill.name}</Skill>
                            )}
                        </SkillsList>
                    </Item>
                ))}
            </List>
        </SectionBlock>
    );
};

export default Articles;
